import { Component } from '@angular/core';
import {
  MunilyCheckboxListCheckboxType,
  MunilyCheckboxListLayout,
  MunilyCheckboxListOption,
  MunilyCheckboxListSelectionMode,
} from 'src/app/common-components/checkbox-list/checkbox-list.types';

type OptionValue = 'opt_a' | 'opt_b' | 'opt_c' | 'opt_d';

@Component({
  selector: 'app-checkbox-list-playground',
  templateUrl: './checkbox-list-playground.component.html',
  styleUrls: ['./checkbox-list-playground.component.scss'],
})
export class CheckboxListPlaygroundComponent {
  titleKey = 'uiKitExamples.checkboxList.title';

  checkboxType: MunilyCheckboxListCheckboxType = 'bullet';
  selectionMode: MunilyCheckboxListSelectionMode = 'single';
  layout: MunilyCheckboxListLayout = 'rows';
  columns = 2;
  disabled = false;

  value: OptionValue | null = 'opt_a';
  values: OptionValue[] = ['opt_a', 'opt_c'];

  readonly checkboxTypes: MunilyCheckboxListCheckboxType[] = ['bullet', 'check_box', 'check_circle'];
  readonly selectionModes: MunilyCheckboxListSelectionMode[] = ['single', 'multiple'];
  readonly layouts: MunilyCheckboxListLayout[] = ['rows', 'columns'];

  readonly options: MunilyCheckboxListOption<OptionValue>[] = [
    { value: 'opt_a', labelKey: 'uiKitExamples.checkboxList.optionA' },
    { value: 'opt_b', labelKey: 'uiKitExamples.checkboxList.optionB' },
    { value: 'opt_c', labelKey: 'uiKitExamples.checkboxList.optionC' },
    { value: 'opt_d', labelKey: 'uiKitExamples.checkboxList.optionD' },
  ];

  lastEvent = '';

  onSelectionChange(v: OptionValue | OptionValue[] | null): void {
    this.lastEvent = `selectionChange: ${JSON.stringify(v)} @ ${new Date().toLocaleTimeString()}`;
    if (this.selectionMode === 'multiple') {
      this.values = Array.isArray(v) ? v : [];
      return;
    }
    this.value = !Array.isArray(v) ? (v as OptionValue | null) : null;
  }
}

